import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  WheelOperationDto,
  WheelOperationReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import WheelOperationInline from "./WheelOperationInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: WheelOperationDto | WheelOperationReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function WheelOperationLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.WheelOperationRead]}
      to={ROUTE_PATH.WHEEL_OPERATION_VIEW(entity?.id || entityId || "")}
      content={<WheelOperationInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
